import request from '@/common/request'

const basePath = '/mensageria-almode'

export interface DisparoDeMensagemVoucherCommand {
	cpfOuCnpj?: string
	dataInicio: string
	dataFinal: string
	tipos: string[]
	lojaId: string
	acaoDeCashbackId?: string
	grupoEconomicoId?: string
}

export const enviaComprovanteDaVendaViaMensageriaAlmode = (vendaId: string, novoTelefone?: string): Promise<void> =>
	request.post(novoTelefone
		? `${basePath}/comprovante-venda/${vendaId}?novoTelefone=${novoTelefone}`
		: `${basePath}/comprovante-venda/${vendaId}`)

export const enviaFechamentoDeCaixaViaMensageriaAlmode = (
	wppFechamento: string,
	body: { base64: string; lojaId: string; pdvId: string },
): Promise<void> =>
	request.post(`${basePath}/fechamento/${wppFechamento}`, body)

export const enviaValePresenteViaMensageriaAlmode = (vendaId: string): Promise<void> =>
	request.post(`${basePath}/vale-presente/${vendaId}`)

export const enviaIdentificadorDoPedidoCriadoViaMensageriaAlmode = (lojaId: string, identificador: string): Promise<void> =>
	request.post(`${basePath}/${lojaId}/pedido-criado/${identificador}`)

export const enviaLinkPagamentoAsaasViaMensageriaAlmode = (
	lojaId: string,
	body: any,
): Promise<void> =>
	request.post(`${basePath}/link-pagamento/${lojaId}`, body)

export const enviaAcaoDeCashbackViaMensageriaAlmode = (command: DisparoDeMensagemVoucherCommand): Promise<void> =>
	request.post(`${basePath}/acao-cashback`, command)

export const enviarAvaliacaoNpsViaMensageriaAlmode = (vendaId: string): Promise<void> =>
	request.post(`${basePath}/avaliacao-nps/${vendaId}`)
